import { Component, inject, Input, OnInit } from '@angular/core';
import { Platform } from 'src/app/models/platform';
import { Tier } from 'src/app/models/tier.model';
import { TypeNote } from 'src/app/models/type-note.model';
import { PlatformService } from 'src/app/services/platform.service';
import { TiersService } from 'src/app/services/tiers.service';
import { TypeNotesService } from 'src/app/services/type-notes.service';
import { environment } from 'src/environments/environment';
import { TenantLocalService } from 'src/app/services/tenantlocal.service';

@Component({
  selector: 'app-impact-row',
  templateUrl: './impact-row.component.html',
  styleUrls: ['./impact-row.component.css']
})
export class ImpactRowComponent implements OnInit {

  @Input('item')
  set inputItem(value: any) {
    this.item = value;
  }
  item: any;
  @Input() xlabel: number;
  @Input() ylabel: number;
  @Input() val: boolean;
  @Input() det: boolean;
  @Input() currency: 'sol' | 'dolar';
  @Input('typeNotesService')
  set inputTypeNotesService(value: TypeNotesService) {
    this.typeNotesService = value;
  }

  typeNotesService: TypeNotesService;
  
  @Input() tiersService: TiersService;
  // set valueTiersService(value: TiersService) {
  //   this.tiersService = value;
  // }

  @Input() platformService: PlatformService;

  someDefaultImage = '/assets/img/noimage.png';
  tenantSlug: string | null = null;

  // typeNotesService: TypeNotesService;
  // tiersService: TiersService;
  // platformService: PlatformService;
  
  // typeNotes: TypeNote[] = [];
  // tiers: Tier[] = [];
  // platforms: Platform[] = [];

  constructor(private tenantLocalService: TenantLocalService) {}

  ngOnInit(): void {
    this.tenantSlug = this.tenantLocalService.getTenantSlug();
  }

  goTo(url): void {
    window.open(url, '_blank');
  }

  get colorTipoNota() {
    const typeNotes = this.typeNotesService.getTypeNotes();
    const styles = typeNotes.filter(({ id }) => id === this.item.tipoNota).map(stylesFn);

    return styles[0];
  }

  get colorTier() {
    const tiers = this.tiersService.getTiers();
    const styles = tiers.filter(({ id }) => id === this.item.tipoTier).map(stylesFn);

    return styles[0];
  }

  get colorPlatform() {
    const plataformas = this.platformService.getPlatforms();
    const styles = plataformas.filter(({ id }) => id === this.item.idPlataforma).map(stylesFn);

    return styles[0];
  }
}

const stylesFn = (obj) => {
  return {
    'background-color': obj.backgroundColor,
    'color': obj.textColor
  }

}
